<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Change name</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <div class="flex flex-col gap-4">
        <Input
          v-model="firstName"
          size="xl"
          label="First name"
          :disabled="loading"
        />
        <Input
          v-model="lastName"
          size="xl"
          label="Last name"
          :disabled="loading"
        />
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeName } from './useChangeName'

const { close } = useSheet()

const props = defineProps<{
  user: User
}>()

const { firstName, lastName, loading, canSave, save } = useChangeName(
  props.user
)

const handleSave = async () => {
  if (await save()) close()
}
</script>
